<template>
    <div class="attachment" @click="download" v-ripple>
        <div class="file-icon">
            <v-icon :class="color" medium>{{ icon }}</v-icon>
        </div>
        <div class="text">
            <p class="body-2">{{ name }}</p>
            <p class="caption">{{ identification }} &bull; {{ size }} &bull; {{ extension }}</p>
        </div>
        <v-tooltip left>
            <div v-if="canRemove" class="actions" @click.stop="remove" slot="activator">
                <v-icon>fa-times</v-icon>
            </div>
            <span>{{$t('tooltip.remove')}}</span>
        </v-tooltip>
        <v-progress-linear height="3" v-bind:value="progress" background-color="grey lighten-3"></v-progress-linear>
    </div>
</template>

<script>
import utilities from '@/helpers/utilities';
import { download } from '@/helpers/download';

export default {
    props: {
        file: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        removeable: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        return {
            canRemove: this.removeable || false,
            progress: 0,
        };
    },
    computed: {
        name() {
            return utilities.splitFileNameExtension(this.file.fileName)[0];
        },
        extension() {
            return utilities.splitFileNameExtension(this.file.fileName)[1];
        },
        size() {
            return `${utilities.numberToDataString(this.file.contentLength / 1024)} KB`;
        },
        icon() {
            return utilities.mimeToFontAwesome(this.file.contentType);
        },
        color() {
            return utilities.fontAwesomeFileIconToClass(this.icon);
        },
        identification() {
            return `Arquivo ${this.index + 1}`;
        },
    },
    methods: {
        download() {
            const file = this.file;

            if (!utilities.isEmptyOrZero(file.content)) {
                download(file.content, file.fileName, file.contentType);
            } else {
                const index = file.links.map(file => file.rel).indexOf('download');
                const url = file.links[index].href;
                this.ajaxDownload(url, file.contentType, file.fileName);
                // download(null, file.fileName, file.contentType, url, this.callback);
            }
        },
        remove() {
            this.$emit('remove', this.file);
        },
        callback(evt) {
            const size = this.file.contentLength;

            this.progress = (evt.loaded / size) * 100;

            if (evt.loaded === size) this.progress = 0;
        },
        ajaxDownload(url, type, name) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'arraybuffer';
            xhr.send();
            xhr.onprogress = this.callback;

            xhr.onload = function onload() {
                if (this.status === 200) {
                    const blob = new Blob([this.response], { type });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = name;
                    link.click();
                    link.remove();
                }
            };
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/components/shared/File.vue